import React, { useState, useEffect } from "react";
import axios from "axios";

import { Link } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
// Importação de ícones (Instale com: npm install react-icons)
import { FaShoppingCart, FaHamburger, FaCocktail, FaLemon } from 'react-icons/fa';
import { LiaHamburgerSolid } from "react-icons/lia";

import logo from '../../assets/images/logo.png';
import './styles.css';

// Função auxiliar para mapear o nome da categoria a um ícone
const getCategoryIcon = (categoryName) => {
  const lowerName = categoryName.toLowerCase();
  // if (lowerName.includes('sanduíche') || lowerName.includes('burger')) return <FaHamburger className="me-1" />;
  // if (lowerName.includes('refrigerante')) return <FaCocktail className="me-1" />;
  // if (lowerName.includes('suco') || lowerName.includes('bebida')) return <FaLemon className="me-1" />;
  return null; // Ícone padrão para outras categorias
};

const NavBar = () => {

  const [categories, setCategories] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      // Usando um endpoint de teste para garantir que o código funcione
      const response = await axios.get("https://apicardapio.gigabytetelecom.com.br:3001/api/categories");
      setCategories(response.data);
    } catch (error) {
      console.error("Erro ao buscar categorias:", error);
    }
  };

  const handleLinkClick = () => {
    setExpanded(false);
  };

  return (
    <>
      {/* Opcional: Aqui você pode adicionar um banner promocional ou de info */}
      {/* <div className="navbar-top">
        <p>📞 Faça seu pedido: (XX) XXXX-XXXX</p>
      </div> */}

      <Navbar expand="lg" fixed="top" className="custom-navbar" expanded={expanded}>
        <Container fluid className="d-flex align-items-center">

          {/* Logo - Usando 'as={Link}' para manter a navegação React Router */}
          <Navbar.Brand as={Link} to="/" className="navbar-logo me-4">
            <img src={logo} alt="Logo Tribo da Fome" />
          </Navbar.Brand>

          {/* Frase de Chamada - Centralizada e oculta em mobile para liberar espaço */}
          <div className="navbar-text d-none d-md-block flex-grow-1 text-center">
            Pronto para **Devorar**?
          </div>

          {/* Toggler e Botão de Carrinho agrupados para melhor alinhamento no mobile */}
          <div className="d-flex align-items-center ms-auto">
            
            <Button 
                variant="danger" 
                className="cart-button d-none d-lg-block me-3" // Visível apenas em desktop ao lado dos links
                as={Link} to="/carrinho" // Assumindo uma rota para o carrinho
            >
                <FaShoppingCart className="me-1" /> 3326-4755 98407-8304
            </Button>

            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              onClick={() => setExpanded(!expanded)}
              className="custom-toggler" // Classe para estilizar o ícone do hamburguer
            />
          </div>

          <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
            <Nav className="navbar-links-group">

              {/* Links de Categoria */}
              {categories.map((category) => (
                <Nav.Item key={category._id} className="d-flex align-items-center">
                  <Link
                    to={`/products/category/${category._id}`}
                    className="nav-link custom-link"
                    onClick={handleLinkClick}
                  >
                    {getCategoryIcon(category.name)}
                    {category.name}
                  </Link>
                </Nav.Item>
              ))}

              {/* Botão de Carrinho no menu mobile */}
              <Nav.Item className="d-block d-lg-none mt-2 mb-2">
                <Button
                  variant="danger"
                  className="cart-button-mobile w-100"
                  as={Link} to="/carrinho"
                  onClick={handleLinkClick}
                >
                  <FaShoppingCart className="me-2" /> VER MEU PEDIDO
                </Button>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavBar;